import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';

import { H1, Container } from 'components';
import CreateQuoteForm from './CreateQuoteForm';
import AppStore from 'AppStore';
// import QuoteStore from 'app/pages/quotes/QuoteStore';
// import ActionConstants from 'app/utils/ActionConstants';

class CreateQuotePage extends Component {
    componentWillMount = () => {
        AppStore.on('quote_created', this.onQuoteCreated);
    };

    componentWillUnmount = () => {
        AppStore.removeListener('quote_created', this.onQuoteCreated);
    };
    onQuoteCreated = () => {
        const quote = AppStore.getCreatedQuote();
        this.props.history.push('/quote/' + quote.id);
        // const quoteState = { state: ActionConstants.PREVIEW_QUOTE };
    };

    //if(QuoteStore.getState().){
    //this.navigateTo("save");
    // return <PreviewQuote quote = {QuoteStore.getState().quote} />

    // };
    render() {
        return (
            <div className="create-quote-page page">
                <Container>
                    <H1>Calculate Lease Quote</H1>
                    <CreateQuoteForm />
                </Container>
            </div>
        );
    }
}

export default withRouter(CreateQuotePage);



// WEBPACK FOOTER //
// ./src/modules/quote/pages/create-quote/CreateQuotePage.jsx